import { makeStyles } from '@material-ui/core';
import React from 'react';
import { NavLink as NavLinkNative } from 'react-router-dom';

const styles = makeStyles(theme => ({
  listItemActive: {
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    borderLeft: `2px solid ${theme.palette.primary.main}!important`,
    transition: 'border-color 0.5s ease',
    '& svg': {
      color: theme.palette.primary.main,
      transition: 'color 0.5s ease',
    },
  },
}));

const NavLink: React.ForwardRefRenderFunction<any, any> = ({ className, ...rest }, ref) => {
  const classes = styles();
  return (
    <NavLinkNative
      ref={ref}
      {...rest}
      className={state => (state.isActive ? ` ${classes.listItemActive} ${className}` : className)}
    />
  );
};

export default React.forwardRef(NavLink);
